import aboutImage from '../assets/the-pocman-img.jpg';


const AboutPage = () => {
  return (
    <div className="mx-auto px-4 sm:px-6 md:px-12 lg:px-20 xl:px-40 py-12 md:py-16 lg:py-20">
      <div className="max-w-7xl mx-auto flex md:flex-row flex-col md:gap-12 lg:gap-16 xl:gap-20 items-center md:items-start">
        <div className="font-nunito md:w-1/2 lg:flex-grow flex flex-col md:text-left text-center">
          <h1 className="text-2xl sm:text-4xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 md:mb-8 order-1">
            Hi, I am Adrian Bueno
          </h1>

          <div className="md:hidden mb-8 order-2">
            <img
              className="object-cover w-full rounded-2xl shadow-lg"
              alt="A person looking into the camera"
              src={aboutImage}
            />
          </div>

          <div className="space-y-4 md:space-y-6 order-3">
            <p className="leading-relaxed text-left text-base/7 text-lg sm:text-xl md:text-xl lg:text-2xl text-gray-700">
              Born in Ecuador and shaped by rich colors and traditions, I later
              moved to New York, where I spent years working, studying, and
              following my dreams. Today, Münster is home, the place where The
              Pocman began. What started as a small hobby slowly grew into
              something that could live anywhere: on a t-shirt, on the street,
              or in the digital world.
            </p>
            <p className="leading-relaxed text-left text-base/7 text-lg sm:text-xl md:text-xl lg:text-2xl text-gray-700">
              I'm now working toward a new chapter: founding my own animation
              studio, where art, stories, and technology come together to help
              others bring their ideas to life. Everything's possible.
            </p>
          </div>
        </div>

        <div className="hidden md:block md:w-1/2 lg:w-2/5 flex-shrink-0">
          <img
            className="object-cover w-full h-auto rounded-2xl shadow-lg"
            alt="A person looking into the camera"
            src={aboutImage}
          />
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
